import React from 'react';
import { FaLinkedin, FaTwitter, FaGlobe } from 'react-icons/fa';

const Footer = () => {
  const isMainSite = window.location.pathname === '/';
  
  // Footer content for main Caishen Capital site
  const mainSiteContent = (
    <>
      {/* Company Info */}
      <div className="col-span-1 lg:col-span-1">
        <div className="flex items-center mb-4">
          <div className="relative">
            <img 
              src="/images/caishen-capital-logo.svg" 
              alt="Caishen Capital Ltd" 
              className="h-24 md:h-28 object-contain"
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = 'none';
                // Safe fallback without innerHTML
                const fallback = document.createElement('div');
                fallback.className = 'text-2xl font-display font-bold flex items-center';
                const span1 = document.createElement('span');
                span1.className = 'text-accent-gold';
                span1.textContent = 'CAISHEN';
                const span2 = document.createElement('span');
                span2.className = 'text-white ml-1';
                span2.textContent = 'CAPITAL';
                fallback.appendChild(span1);
                fallback.appendChild(span2);
                e.target.parentNode.appendChild(fallback);
              }}
            />
          </div>
        </div>
        <p className="text-gray-400 mb-6">
          Caishen Capital is a family office focused on strategic investments in transformative technologies 
          across cyberwarfare, hydrocarbon, fintech and digital assets, AI, and metals & minerals.
        </p>
      </div>

      {/* Quick Links */}
      <div>
        <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
        <ul className="space-y-2">
          <li>
            <a 
              href="#home" 
              className="text-gray-400 hover:text-white transition-colors"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              Home
            </a>
          </li>
          <li>
            <a 
              href="#about" 
              className="text-gray-400 hover:text-white transition-colors"
              onClick={(e) => {
                e.preventDefault();
                const element = document.getElementById('about');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              About Us
            </a>
          </li>
          <li>
            <a 
              href="#investment" 
              className="text-gray-400 hover:text-white transition-colors"
              onClick={(e) => {
                e.preventDefault();
                const element = document.getElementById('investment-approach');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Investment
            </a>
          </li>
          <li>
            <a 
              href="#portfolio" 
              className="text-gray-400 hover:text-white transition-colors"
              onClick={(e) => {
                e.preventDefault();
                const element = document.getElementById('portfolio');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Our Portfolio
            </a>
          </li>
          <li>
            <a 
              href="#contact" 
              className="text-gray-400 hover:text-white transition-colors"
              onClick={(e) => {
                e.preventDefault();
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Contact Us
            </a>
          </li>
        </ul>
      </div>

      {/* Investment */}
      <div>
        <h3 className="text-lg font-semibold mb-4">Investment Approach</h3>
        <ul className="space-y-2">
          <li>
            <a 
              href="#investment-approach" 
              className="text-gray-400 hover:text-white transition-colors"
              onClick={(e) => {
                e.preventDefault();
                const element = document.getElementById('investment-approach');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Investment Approach
            </a>
          </li>
          <li>
            <a 
              href="#investment-criteria" 
              className="text-gray-400 hover:text-white transition-colors"
              onClick={(e) => {
                e.preventDefault();
                const element = document.getElementById('investment-criteria');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Investment Criteria
            </a>
          </li>
          <li>
            <a 
              href="#investment-stages" 
              className="text-gray-400 hover:text-white transition-colors"
              onClick={(e) => {
                e.preventDefault();
                const element = document.getElementById('investment-stages');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Investment Stages
            </a>
          </li>
        </ul>
      </div>
      
      {/* Sectors */}
      <div>
        <h3 className="text-lg font-semibold mb-4">Our Sectors</h3>
        <ul className="space-y-2">
          <li>
            <a href="#sectors" className="text-gray-400 hover:text-white transition-colors">Cyberwarfare</a>
          </li>
          <li>
            <a href="#sectors" className="text-gray-400 hover:text-white transition-colors">Hydrocarbon</a>
          </li>
          <li>
            <a href="#sectors" className="text-gray-400 hover:text-white transition-colors">Fintech and Digital Assets</a>
          </li>
          <li>
            <a href="#sectors" className="text-gray-400 hover:text-white transition-colors">AI</a>
          </li>
          <li>
            <a href="#sectors" className="text-gray-400 hover:text-white transition-colors">Metals & Minerals</a>
          </li>
        </ul>
      </div>
    </>
  );
  
  // Footer content for Trading site
  const tradingSiteContent = (
    <>
      {/* Company Info */}
      <div className="col-span-1 lg:col-span-1">
        <div className="flex items-center mb-4">
          <div className="relative">
            <img 
              src="/images/caishen-trading-logo.svg" 
              alt="Caishen Trading" 
              className="h-24 md:h-28 object-contain"
              onError={(e) => {
                e.target.onerror = null;
                e.target.style.display = 'none';
                // Safe fallback without innerHTML
                const fallback = document.createElement('div');
                fallback.className = 'text-2xl font-display font-bold flex items-center';
                const span1 = document.createElement('span');
                span1.className = 'text-accent-gold';
                span1.textContent = 'CAISHEN';
                const span2 = document.createElement('span');
                span2.className = 'text-white ml-1';
                span2.textContent = 'TRADING';
                fallback.appendChild(span1);
                fallback.appendChild(span2);
                e.target.parentNode.appendChild(fallback);
              }}
            />
          </div>
        </div>
        <p className="text-gray-400 mb-6">
          Premier hydrocarbon and fuels trading house with expertise in EN590, 
          crude oil, D6 and Jet A1 fuel. Delivering value through strategic 
          global partnerships.
        </p>
      </div>

      {/* Quick Links */}
      <div>
        <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
        <ul className="space-y-2">
          <li>
            <a href="#home" className="text-gray-400 hover:text-white transition-colors">Home</a>
          </li>
          <li>
            <a href="#about" className="text-gray-400 hover:text-white transition-colors">About Us</a>
          </li>
          <li>
            <a href="#products" className="text-gray-400 hover:text-white transition-colors">Products</a>
          </li>
          <li>
            <a href="#trading" className="text-gray-400 hover:text-white transition-colors">Trading Process</a>
          </li>
          <li>
            <a href="#insights" className="text-gray-400 hover:text-white transition-colors">Market Insights</a>
          </li>
          <li>
            <a href="#contact" className="text-gray-400 hover:text-white transition-colors">Contact</a>
          </li>
        </ul>
      </div>

      {/* Products */}
      <div>
        <h3 className="text-lg font-semibold mb-4">Our Products</h3>
        <ul className="space-y-2">
          <li>
            <a href="#en590" className="text-gray-400 hover:text-white transition-colors">EN590 Diesel</a>
          </li>
          <li>
            <a href="#crude-oil" className="text-gray-400 hover:text-white transition-colors">Crude Oil</a>
          </li>
          <li>
            <a href="#d6-fuel" className="text-gray-400 hover:text-white transition-colors">D6 Fuel Oil</a>
          </li>
          <li>
            <a href="#jet-a1" className="text-gray-400 hover:text-white transition-colors">Jet A1 Fuel</a>
          </li>
        </ul>
      </div>
    </>
  );
  
  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {isMainSite ? mainSiteContent : tradingSiteContent}
          
          {/* Contact - Common to both sites */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <p>Caishen Capital Ltd.</p>
                <p>Govant Building, BP 1276, Port Vila</p>
                <p>Efate, Vanuatu</p>
              </li>
              <li className="pt-2">
                <p>Email: {isMainSite ? 'info@caishen.capital' : 'trading@caishen.capital'}</p>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center md:flex md:justify-between md:text-left">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Caishen Capital Ltd. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 space-x-4 text-sm text-gray-500">
            <a 
              href="#privacy" 
              className="hover:text-gray-300 transition-colors"
              onClick={(e) => {
                e.preventDefault();
                const element = document.getElementById('privacy');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Privacy Policy
            </a>
            <a 
              href="#terms" 
              className="hover:text-gray-300 transition-colors"
              onClick={(e) => {
                e.preventDefault();
                const element = document.getElementById('terms');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Terms of Service
            </a>
            <a 
              href="#cookies" 
              className="hover:text-gray-300 transition-colors"
              onClick={(e) => {
                e.preventDefault();
                const element = document.getElementById('cookies');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              Cookies Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;